import type { LiveEvent } from '@rp/contracts'
import { useState } from 'react'
import { deviceStorage } from '../../design/typeScale'
import { LIVE_COPY } from './copy'
import { showDesktopNotification } from './desktopNotification'
import { playAlertTone, readSoundEnabled } from './sound'

export interface LiveAlertInputs {
  openItem: (conversationId: string) => void
  pushHandlesDesktop: boolean
}

export interface LiveToastState {
  key: string
  conversationId: string
}

export interface LiveAlerts {
  toast: LiveToastState | null
  dismissToast: () => void
  onInbox: (event: LiveEvent) => void
}

export const useLiveAlerts = ({ openItem, pushHandlesDesktop }: LiveAlertInputs): LiveAlerts => {
  const [toast, setToast] = useState<LiveToastState | null>(null)

  const onInbox = ({ conversationId }: LiveEvent) => {
    const hidden = document.hidden
    if (!hidden) setToast({ key: crypto.randomUUID(), conversationId })
    if (readSoundEnabled(deviceStorage())) playAlertTone()
    if (pushHandlesDesktop) return
    showDesktopNotification({
      title: LIVE_COPY.notificationTitle,
      body: LIVE_COPY.notificationBody,
      tag: conversationId,
      onClick: () => openItem(conversationId),
    })
  }

  return { toast, dismissToast: () => setToast(null), onInbox }
}
